import { create } from 'zustand';
import { cloneDeep } from 'lodash';
import { v4 } from 'uuid';

// eslint-disable-next-line import/prefer-default-export
export const useHomeCustomizationStore = create(set => ({
  editMode: false,
  toggleEditMode: () => set(prevState => ({ editMode: !prevState.editMode })),
  homeState: [],
  setHomeState: nextState => set({ homeState: cloneDeep(nextState) }),
  addNewGroup: () => {
    set(prevState => ({
      homeState: [
        ...prevState.homeState,
        { id: v4(), name: 'New Group', homePageLinks: [], new: true },
      ],
    }));
  },
  updateGroup: ({ name, id }) =>
    set(prevState => {
      const nextState = [...prevState.homeState],
        groupIndex = nextState.findIndex(e => e.id === id);
      delete nextState[groupIndex].new;
      nextState[groupIndex] = {
        ...nextState[groupIndex],
        name,
      };
      return {
        homeState: nextState,
      };
    }),
  removeGroup: groupId => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm('Remove this group?');
    if (!result) return;
    set(prevState => {
      return {
        homeState: prevState.homeState.filter(e => e.id !== groupId),
      };
    });
  },
  addNewLink: groupId => {
    set(prevState => {
      const nextState = [...prevState.homeState],
        groupIndex = nextState.findIndex(e => e.id === groupId);
      nextState[groupIndex] = {
        ...nextState[groupIndex],
        homePageLinks: [
          ...nextState[groupIndex].homePageLinks,
          {
            id: v4(),
            link: '',
            name: '',
            isInternal: false,
            new: true,
          },
        ],
      };
      return {
        homeState: nextState,
      };
    });
  },
  updateLinkOrders: (groupId, links) => {
    set(prevState => {
      const nextState = [...prevState.homeState],
        groupIndex = nextState.findIndex(e => e.id === groupId);
      nextState[groupIndex] = {
        ...nextState[groupIndex],
        homePageLinks: links,
      };
      return {
        homeState: nextState,
      };
    });
  },
  updateLink: (groupId, linkId, payload) => {
    set(prevState => {
      const nextState = [...prevState.homeState],
        groupIndex = nextState.findIndex(e => e.id === groupId),
        linkIndex = nextState[groupIndex].homePageLinks.findIndex(
          e => e.id === linkId,
        );
      delete nextState[groupIndex].homePageLinks[linkIndex].new;
      nextState[groupIndex].homePageLinks[linkIndex] = {
        ...nextState[groupIndex].homePageLinks[linkIndex],
        ...payload,
      };
      return {
        homeState: nextState,
      };
    });
  },
  removeLink: (groupId, linkId) => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm('Remove this link?');
    if (!result) return;
    set(prevState => {
      const nextState = [...prevState.homeState],
        groupIndex = nextState.findIndex(e => e.id === groupId);
      nextState[groupIndex].homePageLinks = nextState[
        groupIndex
      ].homePageLinks.filter(e => e.id !== linkId);
      return {
        homeState: nextState,
      };
    });
  },
}));
